export default __webpack_public_path__ + "static/media/120221526_10158844265006369_6785176384684935922_n.834b8daf.jpg";